import { GoogleSlidesIcon } from '../../../assets/icons/google-slides';
import { createEmbedProvider } from '../factory';

/**
 * Google Slides URL regex pattern
 * Matches: docs.google.com/presentation/d/PRESENTATION_ID/...
 * Captures the presentation ID in group 1.
 */
export const GOOGLE_SLIDES_REGEX = /^https?:\/\/docs\.google\.com\/presentation\/d\/([^/?#]+)/i;

export const googleSlidesProvider = createEmbedProvider({
  id: 'google-slides',
  label: 'Google Slides',
  icon: <GoogleSlidesIcon className="size-5" />,
  regex: GOOGLE_SLIDES_REGEX,
  buildEmbedUrl: (match) => `https://docs.google.com/presentation/d/${match[1]}/embed`,
});
